import { api } from './index';

export interface ProductRequestFormData extends ProductRequest {
  clientAccountId: number
}

export const productRequestsApi = {
  create(data: Partial<ProductRequestFormData>, picture?: File) {
    const path = '/api/internal/product_requests';

    return api({
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url: path,
      data: { ...data, picture },
    }).then(response => response.data.productRequest as ProductRequest);
  },
};
